import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Importando o Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';

// Importando o Element Plus
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

// Importando o idioma português
import pt from 'element-plus/dist/locale/pt.mjs';

const app = createApp(App);

app.use(router);
app.use(ElementPlus, {
  locale: pt,
});

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.mount('#app');